import { Controller } from '@hotwired/stimulus';

export default class StudentCardReissue extends Controller {
  static targets = [
    'isExpress',
    'expressCost',
    'reasonKind',
    'reasonDetail'
  ];

  static values = {
    expressCost: Number
  }

  connect() {
    this.reasonKindChanged();
    this.isExpressChanged();
  }

  isExpressChanged() {
    const isExpress   = this.isExpressTarget.checked
    const expressCost = isExpress ? this.expressCostValue : 0;

    this.expressCostTarget.textContent = Intl.NumberFormat('ja-JP').format(expressCost);
  }

  reasonKindChanged() {
    this.reasonDetailTarget.disabled = this.reasonKindTarget.value !== 'other';
  }
}
